import React, { useEffect, useState } from 'react'
import useSalePrice from './useSalePrice';
import { useParams } from 'react-router';

const useCalcTotal = (salesData, isLoadingSales, userPhone) => {
  const code = useParams().code
  const [userItemsPrice, setUserItemsPrice] = useState([]);
  // console.log(salesData);
  

  useEffect(() => {
    if (!isLoadingSales) {
      const salesItems = salesData?.salesItems?.map((el) => 
          {
            return {
              sku: el.sku,
              eventCurrentSalesQuantity: el.eventCurrentSalesQuantity,
              marketPriceCP: el.marketPriceCP,
              spoPrice: useSalePrice(el.eventCurrentSalesQuantity, el),
            }
          }
        )
      const userCurrentOrders = code !== 'TpoAll' ? salesData.currentOrders?.filter(el => el.userAcc.phone === userPhone) : salesData.currentOrders
      const totalPriceItems = userCurrentOrders?.map(el => el.items.reduce((acc, item) => acc + (item.marketPriceCP * item.quantity), 0))
      const totalSalePriceItems = userCurrentOrders?.map(el => el.items.reduce((acc, item) => acc + (salesItems.find(el => el.sku === item.sku).spoPrice * item.quantity), 0))

      const totlaPriceInfo = userCurrentOrders.map((el, index) => {
        return {
        total: totalPriceItems[index],
        saleTotal: totalSalePriceItems[index],
      }}) 
      setUserItemsPrice(totlaPriceInfo);
    }
  }, [salesData, isLoadingSales]);
  
  
  return userItemsPrice
}

export default useCalcTotal